import { useState, useEffect, useRef } from 'react'
import LeftArrow from '@components/Icons/LeftArrow.jsx'
import RightArrow from '@components/Icons/RightArrow.jsx'
import NostoRecommendationProduct from './NostoRecommendationProduct'
import { parseNostoRecommendation } from '@utils/utils'
import { useStore } from '@nanostores/react'
import { cartData } from '@stores/cartStore'
const NostoRecommendations = ({ productId, placements, slug }) => {
    const [recommendationSets, setRecommendationSets] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const carousels = useRef({})
    const [scrollX, setScrollX] = useState(0)
    const [scrollEnd, setScrollEnd] = useState(false)
    const $cartData = useStore(cartData)

    useEffect(() => {
        if (!placements || !Array.isArray(placements) || placements.length === 0) {
            setError('NostoRecommendations requires a non-empty placements array prop')
            setLoading(false)
            return
        }

        const fetchRecommendations = async () => {
            try {
                setLoading(true)
                await window.nostojs((api) => {
                    return api.defaultSession()
                        .setResponseMode('HTML')
                        .viewProduct(productId)
                        .setPlacements(placements)
                        .load()
                        .then((response) => {
                            console.log('nosto recommendations', response)
                            if (response?.recommendations) {
                                const sets = placements.map(placement => {
                                    const recommendation = response.recommendations[placement]
                                    const cleanedRecommendation = parseNostoRecommendation(recommendation)
                                    return cleanedRecommendation ? {
                                        key: placement,
                                        title: cleanedRecommendation.recommendationTitle,
                                        products: cleanedRecommendation.products,
                                        ...cleanedRecommendation
                                    } : null
                                }).filter(Boolean)

                                setRecommendationSets(sets)
                            } else {
                                setError('No recommendations found')
                            }
                        })
                        .catch((err) => {
                            setError(err.message || 'Failed to fetch recommendations')
                        })
                })
            } catch (err) {
                setError(err.message || 'Failed to fetch recommendations')
            } finally {
                setLoading(false)
            }
        }

        if (productId) {
            fetchRecommendations()
        }
    }, [productId, placements, $cartData])

    const movePrev = (carouselKey) => {
        const carousel = carousels.current[carouselKey]
        if (carousel) {
            let frameWidth = carousel.firstChild.offsetWidth
            if (window.innerWidth > 800) {
                carousel.scrollLeft -= frameWidth * 3 + 10
            } else {
                carousel.scrollLeft -= frameWidth * 2 + 10
            }
        }
    }

    const moveNext = (carouselKey) => {
        const carousel = carousels.current[carouselKey]
        if (carousel) {
            let frameWidth = carousel.firstChild.offsetWidth
            if (window.innerWidth > 800) {
                carousel.scrollLeft += frameWidth * 3 + 10
            } else {
                carousel.scrollLeft += frameWidth * 2 + 10
            }
        }
    }

    const scrollFunction = (e, carouselKey) => {
        const carousel = carousels.current[carouselKey]
        if (carousel) {
            setScrollX(carousel.scrollLeft)
            if (
                Math.floor(
                    carousel.scrollWidth - carousel.scrollLeft
                ) <= carousel.offsetWidth
            ) {
                setScrollEnd(true)
            } else {
                setScrollEnd(false)
            }
        }
    }

    if (loading) return <div>Loading recommendations...</div>
    if (error) return <div>Error: {error}</div>

    return (
        <div className='my-8'>
            {recommendationSets.map((recommendations) => (
                <div key={recommendations.key} className='nosto-recommendations-outer carousel-outer max-w-[90vw] 2xl:max-w-[1400px] mx-auto mb-8'>
                    <div className='nosto-recommendations-inner carousel-inner wrap-[90vw] overflow-x-hidden lg:wrap-xl mx-auto'>
                        <div className='carousel mx-auto wrap-[90vw] overflow-x-hidden lg:wrap-xl relative'>
                            <div className='carousel-header relative flex flex-col lg:flex-row lg:items-center mb-3 mr-4 items-center justify-center'>
                                <h2 className='text-lg md:text-xl lg:text-2xl '>
                                    {recommendations?.title || 'Recommendations'}
                                </h2>
                                <div className='carousel-header-wrap lg:justify-end lg:ml-auto flex flex-col lg:flex-row items-center gap-3'>
                                    <div className='carousel-nav flex gap-3'>
                                        <div
                                            className={`angle-left ${
                                                scrollX === 0
                                                    ? 'cursor-not-allowed opacity-50'
                                                    : 'cursor-pointer'
                                            }`}
                                            onClick={() => movePrev(recommendations.key)}
                                            disabled={scrollX === 0}
                                        >
                                            <LeftArrow width='w-[32px]' />
                                        </div>
                                        <div
                                            className={`angle-right ${
                                                scrollEnd
                                                    ? 'cursor-not-allowed opacity-50'
                                                    : 'cursor-pointer'
                                            }`}
                                            onClick={() => moveNext(recommendations.key)}
                                            disabled={scrollEnd}
                                        >
                                            <RightArrow width='w-[32px]' />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='relative overflow-x-hidden'>
                                <div
                                    onScroll={(e) => scrollFunction(e, recommendations.key)}
                                    ref={(el) => (carousels.current[recommendations.key] = el)}
                                    className='carousel-container relative grid grid-flow-col auto-cols-[minmax(50%,1fr)] lg:auto-cols-[minmax(230px,230px)] gap-1 overflow-x-scroll scroll-smooth snap-x snap-mandatory touch-pan z-0'
                                >
                                    {recommendations?.products?.map((product) => (
                                        <NostoRecommendationProduct
                                            key={product.productId}
                                            product={product}
                                            slug={slug}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default NostoRecommendations
